export default "__VITE_ASSET__JdNUlhIa__"